import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from "@angular/forms";
import { FlashMessagesService } from "angular2-flash-messages";
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { CommonService } from "../../_services/common.service";
import { Router } from '@angular/router';
import { CommonProjectDataService } from "../../_services/common-project-data.service";

export class CSVRecord {
  public customer_id: any;
  public first_name: any;
  public last_name: any;
  public company_name: any;
  public email: any;
  public phone: any;
  public fax: any;
  public full_billing_address: any;
  public billing_address1: any;
  public billing_address2: any;
  public billing_address_city: any;
  public billing_address_state: any;
  public billing_address_zip: any;
  public billing_address_country: any;
  public full_shipping_address: any;
  public shipping_address1: any;
  public shipping_address2: any;
  public shipping_address_city: any;
  public shipping_address_state: any;
  public shipping_address_zip: any;
  public shipping_address_country: any;
  public tax_exempt: any;
  public state_reseller_license: any;
  public created: any;
  public owner_name: any;
  public owner_email: any;
  public is_payment_term: any;
  public net_days: any;
  public validate_address: any;
  public middle_name: any;
  public is_same_as_shipping: any;
}

@Component({
  selector: 'app-client-import',
  templateUrl: './client-import.component.html',
  styleUrls: ['./client-import.component.css']
})
export class ClientImportComponent implements OnInit {
  public userDetails: any = {};
  loading: false;
  public result = "";
  public records: any[] = [];
  public csvData: any[] = [];
  public submitButton = false;
  public progressMsg = 'Import';
  @ViewChild('csvReader') csvReader: any;
  constructor(
    private _flashMessagesService: FlashMessagesService,
    public dialogRef: MatDialogRef<ClientImportComponent>,
    private CommonService: CommonService,
    private router: Router,
    private CommonProjectDataService: CommonProjectDataService
  ) {

  }

  ngOnInit() {
    this.userDetails = JSON.parse(localStorage.getItem("userDetails"));
  }

  uploadListener($event: any): void {
    let text = [];
    let files = $event.srcElement.files;
    if (this.isValidCSVFile(files[0])) {
      let input = $event.target;
      let reader = new FileReader();
      reader.readAsText(input.files[0]);
      reader.onload = () => {
        let csvData = reader.result;
        let csvRecordsArray = (<string>csvData).split(/\r\n|\n/);

        let headersRow = this.getHeaderArray(csvRecordsArray);

        this.records = this.getDataRecordsArrayFromCSVFile(csvRecordsArray, headersRow.length);
        if (this.records.length) {
          this.csvData = this.records;
          this.submitButton = true;
        }
        else {
          this._flashMessagesService.show("Empty .csv file.", {
            cssClass: "alert-warning",
            timeout: 5000
          });
          this.fileReset();
        }
      };
      reader.onerror = function () {
        console.log('error is occured while reading file!');
      };
    }
    else {
      this._flashMessagesService.show("Please import valid .csv file.", {
        cssClass: "alert-warning",
        timeout: 5000
      });
      this.fileReset();
    }
  }

  getDataRecordsArrayFromCSVFile(csvRecordsArray: any, headerLength: any) {
    let csvArr = [];

    for (let i = 1; i < csvRecordsArray.length; i++) {
      let curruntRecord = (<string>csvRecordsArray[i]).split(',');
      if (curruntRecord.length == headerLength) {
        let csvRecord: CSVRecord = new CSVRecord();
        csvRecord.customer_id = curruntRecord[0].trim();
        csvRecord.first_name = curruntRecord[1].trim();
        csvRecord.last_name = curruntRecord[2].trim();
        csvRecord.company_name = curruntRecord[3].trim();
        csvRecord.email = curruntRecord[4].trim();
        csvRecord.phone = curruntRecord[5].trim();
        csvRecord.fax = curruntRecord[6].trim();
        csvRecord.full_billing_address = curruntRecord[7].trim().replace(/""/g, "");
        csvRecord.billing_address1 = curruntRecord[8].trim().replace(/""/g, "");
        csvRecord.billing_address2 = curruntRecord[9].trim().replace(/""/g, "");
        csvRecord.billing_address_city = curruntRecord[10].trim().replace(/""/g, "");
        csvRecord.billing_address_state = curruntRecord[11].trim().replace(/""/g, "");
        csvRecord.billing_address_zip = curruntRecord[12].trim().replace(/""/g, "");
        csvRecord.billing_address_country = curruntRecord[13].trim().replace(/""/g, "");
        csvRecord.full_shipping_address = curruntRecord[14].trim().replace(/""/g, "");
        csvRecord.shipping_address1 = curruntRecord[15].trim().replace(/""/g, "");
        csvRecord.shipping_address2 = curruntRecord[16].trim().replace(/""/g, "");
        csvRecord.shipping_address_city = curruntRecord[17].trim().replace(/""/g, "");
        csvRecord.shipping_address_state = curruntRecord[18].trim().replace(/""/g, "");
        csvRecord.shipping_address_zip = curruntRecord[19].trim().replace(/""/g, "");
        csvRecord.shipping_address_country = curruntRecord[20].trim().replace(/""/g, "");
        csvRecord.tax_exempt = curruntRecord[21].trim();
        csvRecord.state_reseller_license = curruntRecord[22].trim();
        csvRecord.created = curruntRecord[23].trim();
        csvRecord.owner_name = curruntRecord[24].trim();
        csvRecord.owner_email = curruntRecord[25].trim();
        csvRecord.is_payment_term = curruntRecord[26].trim();
        csvRecord.net_days = curruntRecord[27].trim();
        csvRecord.validate_address = false;
        csvRecord.middle_name = "";
        csvRecord.is_same_as_shipping = "No";
        if(curruntRecord[1].trim() !=''){
          csvArr.push(csvRecord);
        }
      }
    }
    return csvArr;
  }
 
  getHeaderArray(csvRecordsArr: any) {
    let headers = (<string>csvRecordsArr[0]).split(',');
    let headerArray = [];
    for (let j = 0; j < headers.length; j++) {
      headerArray.push(headers[j]);
    }
    return headerArray;
  }

  isValidCSVFile(file: any) {
    return file.name.endsWith(".csv");
  }

  fileReset() {
    if (this.csvReader.nativeElement) {
      this.csvReader.nativeElement.value = "";
    }
    this.records = [];
  }

  saveClientFormData = function () {
    if (this.submitButton && this.csvData.length > 0) {
      this.submitButton = false;
      this.progressMsg = 'Importing ....';
      const chunkSize = 500;
      for (let i = 0; i < this.csvData.length; i += chunkSize) {
        var chunkData = this.csvData.slice(i, i + chunkSize);

        var formData = new FormData();
        formData.append('id', this.userDetails.id);
        formData.append('csvData', JSON.stringify(chunkData));
        this.CommonService.apiService(
          "POST",
          "user/import",
          formData
        ).subscribe(
          (response: any) => {
            // console.log(response);
            if (response.status === true) {
              this._flashMessagesService.show(response.message, {
                cssClass: "alert-success",
                timeout: 5000
              });
              this.fileReset();
              this.result = "success";
              this.progressMsg = 'Import';
            }
          },
          err => {
            this._flashMessagesService.show(err.error.message, {
              cssClass: "alert-warning",
              timeout: 5000
            });
          }
        );
      }
    }
    else {
      this._flashMessagesService.show("Empty .csv file.", {
        cssClass: "alert-warning",
        timeout: 5000
      });
      this.fileReset();
    }
  }
  onNoClick(): void {
    if (this.result == "success") {
      this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
        this.router.navigate(['/clients/listing']);
      });
    }
    this.dialogRef.close(this.result);
  }

}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-users/client-import/client-import.component.ts